import { AuthorizationError } from '@auth0/nextjs-auth0/errors'
import { ERROR_CODES, ErrorCodes, GenericException } from '@reward-platform/shared-api/exceptions'

export class Auth0B2CException extends GenericException {
  constructor(error?: AuthorizationError | Error, errorCode: `${ErrorCodes}` = 'REQUEST_INVALID') {
    super({
      ...ERROR_CODES[errorCode],
      description: 'Auth0 B2C Error',
      originalError: error,
    })

    if (error?.message) {
      this.developerMessage = error?.message
    }

    if (error instanceof AuthorizationError && error.code) {
      this.subtype = error.code
      this.system = 'internal-iagl-auth0-b2c'
    }
  }
}
